import dynamic from "next/dynamic";

export const DynamicContent075 = dynamic(() => import("./Content075"), {
  suspense: true,
});
